import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OTPVerification() {
  const [otp, setOtp] = useState(['', '', '', '', '']);
  const navigate = useNavigate();

  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 4) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullOtp = otp.join('').trim();
    const storedOtp = sessionStorage.getItem('otp')?.trim();
    const email = localStorage.getItem('email');

    console.log('🔐 Entered OTP:', fullOtp);
    console.log('📦 Stored OTP:', storedOtp);
    console.log('📤 Sending confirmation email to:', email);

    if (!storedOtp) {
      alert('❌ No OTP found. Please register again.');
      return;
    }

    if (fullOtp === storedOtp) {
      console.log('✅ OTP verified:', fullOtp);

      // ✅ Hydrate tenantId and store in localStorage
      const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
      const tenantId = registry[email]?.tenantId;
      if (tenantId) {
        localStorage.setItem('tenantId', tenantId);
        console.log('🏷️ Hydrated tenantId:', tenantId);
      }

      try {
        const response = await fetch('http://localhost:3001/api/email/send-confirmation-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        });

        const result = await response.json();
        if (result.success) {
          console.log(`📩 Confirmation email sent to ${email}`);
        } else {
          console.error('❌ Error sending confirmation email:', result.error);
        }
      } catch (error) {
        console.error('❌ Network error during confirmation email dispatch:', error);
      }

      navigate('/signin');
    } else {
      alert('❌ Invalid OTP. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="p-8 bg-white rounded shadow w-full max-w-md">
        <button className="mb-4 text-blue-600 hover:underline" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2 className="text-2xl font-bold text-center mb-6">Enter OTP for verification</h2>
        <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-6">
          <div className="flex space-x-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                className="w-12 h-12 text-center text-xl border rounded"
                required
              />
            ))}
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
          >
            Submit OTP
          </button>
        </form>
      </div>
    </div>
  );
}
